import React from "react";
import { ReactComponent as IconEasyPayLogoDashboardFooter } from "../../icons/easyPayFooterLogoNew.svg";
import colors from "../colors";
import Divider from "@mui/material/Divider";
import { Typography, Grid, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { texts } from "../general/texts";

const Footer = (props) => {
  const navigate = useNavigate();

  const useStyles = makeStyles({
    mainGrid: {
      width: "65%",
      padding: "2%",
      paddingTop: "3%",
      paddingBottom: "3%",
    },
    iconGrid: {
      "@media (max-width: 899px)": {
        justifyContent: "center",
        paddingBottom: "3%",
      },
    },
    link: {
      color: colors.gray,
      fontSize: "1rem",
      textDecoration: "none",
      fontFamily: "GerberaLight",
      "&:hover": {
        textDecorationColor: "#FF8403",
        textDecoration: "underline",
        color: "#FF8403",
      },
    },
    linkBottom: {
      color: colors.gray,
      textDecorationColor: colors.gray,
      fontFamily: "GerberaLight",
      "&:hover": {
        textDecorationColor: "#FF8403",
        textDecoration: "underline",
        color: "#FF8403",
      },
    },
    text: {
      color: colors.darkBlue,
      fontFamily: "GerberaLight",
    },
    divider: {
      background: colors.orange,
      borderWidth: 0.5,
      width: "0.1%",
    },
  });

  const classes = useStyles();

  return (
    <Grid
      container
      item
      width={"100%"}
      md={12}
      justifyContent="center"
      backgroundColor={colors.white}
    >
      <Grid container item className={classes.mainGrid}>
        <Grid
          container
          item
          justifyContent="left"
          md={4}
          xs={12}
          className={classes.iconGrid}
        >
          <IconEasyPayLogoDashboardFooter />
        </Grid>
        <Grid
          container
          item
          md={8}
          xs={12}
          justifyContent="right"
          sx={{ "@media (max-width: 899px)": { justifyContent: "center" } }}
        >
          <Grid item md={2} xs={4}>
            <Link
              onClick={() => {
                navigate("/popularQuestions");
              }}
              component="button"
              className={classes.link}
              variant="body2"
            >
              {texts["placeholder-help-support-footer"]}
            </Link>
          </Grid>
          <Grid item md={4} xs={4}>
            <Link
              href="https://easypay.al/support.html"
              target="_blank"
              className={classes.link}
              variant="body2"
            >
              {texts["placeholder-contact-footer"]}
            </Link>
          </Grid>
        </Grid>
        <Grid item md={12} pt={"2%"}>
          <Divider />
        </Grid>
        <Grid
          container
          item
          md={5}
          xs={12}
          pt={"2%"}
          sx={{ "@media (max-width: 899px)": { justifyContent: "center" } }}
        >
          <Typography className={classes.text}>
            EasyPay v1.0 / 2013-{new Date().getFullYear()}{" "}
            {texts["title-all-rights"]}
          </Typography>
        </Grid>
        <Grid container item spacing={4} md={6} xs={12} pt={"2%"}>
          <Grid item md={0} display={{ xs: "none", md: "block" }}>
            <Divider className={classes.divider} orientation="vertical" />
          </Grid>
          <Grid item md={3.5} xs={12}>
            <Link
              href={props.termsAndConditionsUrl}
              target="_blank"
              className={classes.linkBottom}
              variant="body2"
            >
              {texts["title-terms-and-conditions"]}
            </Link>
          </Grid>
          <Grid item md={3.5} xs={12}>
            <Link
              href={props.privacyUrl}
              target="_blank"
              className={classes.linkBottom}
              variant="body2"
            >
              {texts["privacy-politics"]}
            </Link>
          </Grid>
          <Grid item md={3.5} xs={12}>
            <Link
              href="https://easypay.al/llogaria-easypay/#tarifat-dhe-limitet"
              target="_blank"
              className={classes.linkBottom}
              variant="body2"
            >
              {texts["placeholder-fees-limits"]}
            </Link>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Footer;
